<template>
    <div>

         <ThatsTable title="Items" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @viewSoldTo="viewSoldTo" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm" @viewRelatedDocument="viewRelatedDocument" @tableSearchTerm="tableSearchTerm">

           <!--  <template #filter="{}">
                    <div>test</div>
            </template> -->

            <template #filter="{}">
                <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="SKU" vid="searchTerm" name="searchTerm" v-model="filterForm.searchTerm" size="sm" :disabled="false" :rules="''"/>
                <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Supplier Code" vid="supplierCode" name="supplierCode" v-model="filterForm.supplierCode" size="sm" :disabled="false" :rules="''"/>
                <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Item Name" vid="itemName" name="itemName" v-model="filterForm.itemName" size="sm" :disabled="false" :rules="''"/>
                <!-- <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Group" v-model="filterForm.ItmGroup" :reduce="obj => obj.code" :reduceLabel="'brand'" :options="groups" :rules="''"></ThatsAutocomplete> -->
                <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Brand" v-model="filterForm.brands" :reduce="obj => obj.code" :reduceLabel="'brand'" :options="brands" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :clearable="false" tabindex="7" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Product Department" v-model="filterForm.product_department_id" :reduce="obj => obj.value" :reduceLabel="'label'" :options="productDepartmentOptions" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :clearable="false" tabindex="8" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Product Category" v-model="filterForm.product_category_id" :reduce="obj => obj.value" :reduceLabel="'label'" :options="filteredProductCategoryOptions" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :clearable="false" tabindex="9" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Product Type" v-model="filterForm.product_type_id" :reduce="obj => obj.value" :reduceLabel="'label'" :options="filteredProductTypeOptions" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :multiple="true" :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Product Attributes" v-model="filterForm.product_attribute_id" :reduce="obj => obj.value" :reduceLabel="'label'" :options="productAttributeOptions" :rules="''" :disabled="productAttributesLoading || productTypeAttributesLoading"></ThatsAutocomplete>
                <template v-for="attribute in selectedFilterAttributes">
                    <ThatsInput v-if="attribute.data_type === 'TEXT'" :key="`filter-attribute-text-${attribute.id}`" :label="attribute.name" :vid="`filter-attribute-${attribute.id}`" :name="`filter-attribute-${attribute.id}`" v-model="filterForm.product_attribute_filters[attribute.id]" size="sm" :rules="''" />
                    <ThatsNumber v-else-if="attribute.data_type === 'NUMBER' || attribute.data_type === 'DECIMAL'" :key="`filter-attribute-number-${attribute.id}`" :label="attribute.name" :vid="`filter-attribute-${attribute.id}`" :name="`filter-attribute-${attribute.id}`" v-model="filterForm.product_attribute_filters[attribute.id]" size="sm" />
                    <ThatsRadio v-else-if="attribute.data_type === 'BOOLEAN'" :key="`filter-attribute-boolean-${attribute.id}`" :label="attribute.name" :vid="`filter-attribute-${attribute.id}`" :name="`filter-attribute-${attribute.id}`" orientation="inline" :data="[{ label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }]" v-model="filterForm.product_attribute_filters[attribute.id]" size="sm" />
                    <ThatsMultiSelect v-else-if="attribute.data_type === 'LIST'" :key="`filter-attribute-list-${attribute.id}`" :label="attribute.name" :vid="`filter-attribute-${attribute.id}`" :name="`filter-attribute-${attribute.id}`" v-model="filterForm.product_attribute_filters[attribute.id]" :options="attribute.options || []" :multiple="false" :reduce="option => option.id" :reduceLabel="'value'" size="sm" />
                </template>
                <ThatsAutocomplete :clearable="false" tabindex="11" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Collections" v-model="filterForm.collection" :reduce="obj => obj.mdbID" :reduceLabel="'name'" :options="collections" :rules="''"></ThatsAutocomplete>
                <!-- <ThatsAutocomplete :multiple="true" :clearable="false" tabindex="12" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Category" v-model="filterForm.category" :reduce="obj => obj.id" :reduceLabel="'name'" :options="filteredCategory" :rules="''"></ThatsAutocomplete> -->
                <!-- 
                <ThatsAutocomplete :multiple="false" :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="MaterialS" v-model="filterForm.materials" :reduce="obj => obj.name" :reduceLabel="'name'" :options="materials" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :multiple="false" :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Colour" v-model="filterForm.colour" :reduce="obj => obj.name" :reduceLabel="'name'" :options="colours" :rules="''"></ThatsAutocomplete>
                <ThatsAutocomplete :multiple="false" :clearable="false" tabindex="10" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Attribute" v-model="filterForm.attribute" :reduce="obj => obj.name" :reduceLabel="'name'" :options="sizes" :rules="''"></ThatsAutocomplete>
                 -->
               <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Status" v-model="filterForm.status" :reduce="label => label.value" :reduceLabel="'label'" :options="itemStatus" :rules="''"></ThatsAutocomplete>
               <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Web Status" v-model="filterForm.website" :reduce="label => label.value" :reduceLabel="'label'" :options="itemWebsiteStatus" :rules="''"></ThatsAutocomplete>
               <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Availability" v-model="filterForm.availability" :reduce="label => label.value" :reduceLabel="'label'" :options="itemAvailabilityStatus" :rules="''"></ThatsAutocomplete>
               <mdb-row>
                    <mdb-col col="3">
                        <label class="col-form-label">QUANTITY RANGE</label>
                    </mdb-col>
                    <mdb-col col="9">
                      <div class="row">
                        <div class="col-md-5 pl-3">
                          <ThatsNumber tabindex="1" labelClass="" fieldClass="col-sm-12 pl-0" vid="rangeone" name="rangeone" v-model="filterForm.range[0]" :key="`slider-${vueSliderCtr}`" size="sm" />
                        </div>
                        <div class="col-md-2">~</div>
                        <div class="col-md-5">
                          <ThatsNumber tabindex="1" labelClass="" fieldClass="col-sm-12 pl-0" vid="rangetwo" name="rangetwo" v-model="filterForm.range[1]" :key="`slider-${vueSliderCtr}`" size="sm" />
                        </div>
                      </div>

                      <mdb-row>
                          <mdb-col col="12 pr-4">
                            <vue-slider class="mt-1 mb-1" v-bind="slider" v-model="filterForm.range" :key="`slider-${vueSliderCtr}`"></vue-slider>
                          </mdb-col>
                      </mdb-row>

                    </mdb-col>
                </mdb-row>

               <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="In Transit" v-model="filterForm.in_transit" :reduce="label => label.value" :reduceLabel="'label'" :options="itemInTransitStatus" :rules="''"></ThatsAutocomplete>
               <ThatsAutocomplete :clearable="false" tabindex="6" :addButton="false" :appendButton="false" labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Under Production" v-model="filterForm.under_production" :reduce="label => label.value" :reduceLabel="'label'" :options="itemUnderProductionStatus" :rules="''"></ThatsAutocomplete>


            </template>


            <template #custom-right-culumns="{}">


            </template>
            <template #button-right="{}">

                <mdb-dropdown multiLevel class="ml-1 barcode-dropdown-toggle" end>
                    <mdb-dropdown-toggle slot="toggle" color="elegant" size="sm">Options</mdb-dropdown-toggle>
                    <mdb-dropdown-menu >

                    <a class="dropdown-item" href="javascript:void(0)" @click.prevent="openBulkAllocationDialog">Bulk Set Allocation</a>
                    <div class="dropdown-divider"></div>

                   
                    
                    <!-- <a class="dropdown-item" href="javascript:void(0)" @click="openBulkUpdateDialog('status')">Update Status</a>
                    <a class="dropdown-item" href="javascript:void(0)" @click="openBulkUpdateDialog('price')">Update Price</a> -->
                    <a class="dropdown-item" href="javascript:void(0)" @click="openBulkCreateDialog">Bulk Create or Update</a>
                   <!--  <a class="dropdown-item" href="javascript:void(0)" @click="openBulkUpdateQuantityDialog">Bulk Update</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openBulkCreateQuantityDialog">Bulk Create</a> -->
                        <a class="dropdown-item" href="javascript:void(0)" @click="openItemIntegrationDialog">Bulk Push to SAP</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openPrintCatalogDialog">Print Catalog</a>
                        
                        <a class="dropdown-item" href="javascript:void(0)" @click="openSyncItemMasterDialog">Sync Item Master</a>
                     <!--    <a class="dropdown-item" href="javascript:void(0)" @click="openPrintAcrylicLabelDialog">Print Acrylic Label</a> -->
                        <a class="dropdown-item" href="javascript:void(0)" @click="openPrintAcrylicLabelDialog">Print Tag Label</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openPrintStickerDialog">Print Sticker</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openEmailSend">Email Send</a>
                        <a class="dropdown-item" href="javascript:void(0)" @click="openBulkPrintDataMatrixDialog">Bulk Print Data Matrix</a>

                        
                    </mdb-dropdown-menu>
                </mdb-dropdown>

            </template>

        </ThatsTable>
        <InventoryItemMasterFormV2 ref="inventoryItemMasterForm" @success="refreshTable"></InventoryItemMasterFormV2>
        <InventoryItemMasterForm ref="inventoryItemMasterFormx" @success="refreshTable"></InventoryItemMasterForm>
        <ItemSoldToWindow ref="itemSoldToWindow" @success="refreshTable" @rowClick="itemSoldRowClickHandler"></ItemSoldToWindow>
        <RelatedDocumentStockHistoryDialog ref="relatedDocumentDialogHistory" title="Inventory Audit" :endpoint="'related-documents/item-stock-history'"></RelatedDocumentStockHistoryDialog>
        <RelatedDocumentPurchaseOrderDialog ref="relatedDocumentDialogPurchaseOrder" title="Purchase Order" :endpoint="'related-documents/purchase-order'"></RelatedDocumentPurchaseOrderDialog>
        <RelatedDocumentIncomingContainerDialog ref="relatedDocumentDialogIncomingContainer" title="Incoming Container" :endpoint="'related-documents/incoming-container'"></RelatedDocumentIncomingContainerDialog>
        <InvoiceForm ref="invoiceForm" :group="3"></InvoiceForm>
        <BulkUpdateCountryOfOrigin ref="bulkUpdateCountryOfOrigin" @success="refreshTable" :group="3"></BulkUpdateCountryOfOrigin>
        <BulkUpdateItem ref="bulkUpdateItem" @success="refreshTable" :group="3" :update="bulkUpdate"></BulkUpdateItem>
        <BulkPrintQrCode ref="bulkPrintQrCode" @success="refreshTable" :group="3"></BulkPrintQrCode>
        <UpdateQuantity ref="updateQuantity" @success="refreshTable" :group="3"></UpdateQuantity>
        <BulkItemCreate ref="bulkCreateDialog" @success="refreshTable" :group="3"></BulkItemCreate>
        <BulkCreateProduct ref="createProduct" @success="refreshTable" :group="3"></BulkCreateProduct>
        <SyncItemMaster ref="syncItemMaster" @success="refreshTable" :group="3"></SyncItemMaster>
        <PrintCatalog ref="printCatalog" @success="refreshTable" :group="3"></PrintCatalog>
        <PrintCatalog2 ref="printCatalog2" @success="refreshTable" :group="3"></PrintCatalog2>
        <PrintCatalog3 ref="acrylicLabel" @success="refreshTable" :group="3"></PrintCatalog3>
        <BulkItemCreateOrUpdate ref="bulkItemCreateOrUpdate" @success="refreshTable" :group="3"></BulkItemCreateOrUpdate>
        <BulkPrintDataMatrix ref="bulkPrintDataMatrix" @success="refreshTable" :group="3"></BulkPrintDataMatrix>
        <ItemIntegrationDialog ref="itemIntegrationDialog" @success="refreshTable" :group="3" :endpoint="'item-master-integration'" :defaultDatabase="'THATSLIVING_DEV'" ></ItemIntegrationDialog>
        <BulkAllocationDialog ref="bulkAllocationDialog" @success="handleBulkAllocationSuccess"></BulkAllocationDialog>

<!--        Send email section-->
        <mdb-modal :show="showModal" @close="showModal = false" class="modal" centered>
            <mdb-modal-header>SEND TO EMAIL</mdb-modal-header>
            <mdb-modal-body>
                <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="Email" vid="email" name="email" v-model="emailForm.email" size="sm" :disabled="false" :rules="''"/>
            </mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="elegant" size="sm" @click="onSubmitEmailForm"><i class="el-icon-save text-white cursor-pointer"></i> Send</mdb-btn>
                <mdb-btn @click="closeModal" color="elegant" size="sm">Close</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './Table'
import {mdbTabs, mdbRow, mdbCol, mdbBtn,mdbSelect,mdbModal,mdbModalHeader,
    mdbModalFooter,  mdbModalBody, mdbInput,mdbBadge,mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem} from 'mdbvue'
import { MessageBox } from 'element-ui';
import DateRangePicker from 'vue2-daterange-picker'

import { ThatsDatePicker, ThatsMultiSelect, ThatsInput, ThatsAutocomplete,ThatsNumber,ThatsRadio} from '../../components/thats/Thats'
import { ApiHttpService } from '../../services'
import ThatsMultiVueSelect from '../../components/thats/MultiVueSelect'
import { ValidationObserver,ValidationProvider } from "vee-validate";

import { Loading } from 'element-ui';
import InventoryItemMasterForm from './InventoryItemMasterForm.vue'
import InventoryItemMasterFormV2 from './InventoryItemMasterFormV2.vue'
// import IntegrationWindow from '../../components/thats/IntegrationWindow.vue'
import ItemSoldToWindow from "./ItemSoldToWindow.vue"
import RelatedDocumentPurchaseOrderDialog from "./RelatedDocumentPurchaseOrderDialog.vue"
import RelatedDocumentStockHistoryDialog from "./RelatedDocumentStockHistoryDialog.vue"
import RelatedDocumentIncomingContainerDialog from "./RelatedDocumentIncomingContainerDialog.vue"
import InvoiceForm from '../transaction/InvoiceForm.vue'
import BulkUpdateCountryOfOrigin from './BulkUpdateCountryOfOrigin'
import BulkPrintQrCode from './BulkPrintQrCode'
import PrintAcrylicLabel from './PrintAcrylicLabel'
import BulkUpdateItem from './BulkUpdateItem.vue';
import VueSlider from 'vue-slider-component'
import UpdateQuantity from './UpdateQuantity.vue';
import BulkCreateProduct from "./BulkCreateProduct";
import PrintCatalog from "./PrintCatalog";
import PrintCatalog2 from "./PrintCatalog2";
import SyncItemMaster from "./SyncItemMaster";
import BulkPrintDataMatrix from "./BulkPrintDataMatrix";
import ItemIntegrationDialog from "./ItemIntegrationDialog";
import PrintCatalog3 from "./PrintCatalog3";
import BulkItemCreate from "./BulkItemCreate";
import BulkItemCreateOrUpdate from "./BulkItemCreateOrUpdate";
import BulkAllocationDialog from './BulkAllocationDialog.vue'
export default {
        components:{
            BulkItemCreateOrUpdate,
            BulkItemCreate,
            SyncItemMaster,
            BulkCreateProduct,
            PrintCatalog,
            PrintCatalog2,
            PrintCatalog3,
            ThatsInput,
            ThatsTable,
            mdbTabs,
            mdbBadge,mdbModalHeader,
            mdbModalBody, mdbModalFooter, mdbModal,
            DateRangePicker, mdbRow, mdbCol,
            ThatsDatePicker,
            mdbBtn,
            mdbDropdown,mdbDropdownToggle,mdbDropdownMenu,mdbDropdownItem,
            ThatsMultiSelect,
            ThatsRadio,
            ValidationObserver,ValidationProvider,ThatsMultiVueSelect,InventoryItemMasterForm,InventoryItemMasterFormV2,
            mdbSelect,
            mdbInput,
            ItemSoldToWindow,
            InvoiceForm,
            ThatsAutocomplete,
            BulkUpdateCountryOfOrigin,
            BulkPrintQrCode,
            RelatedDocumentStockHistoryDialog,
            RelatedDocumentPurchaseOrderDialog,
            RelatedDocumentIncomingContainerDialog,
            BulkUpdateItem,
            VueSlider,
            ThatsNumber,
            UpdateQuantity,
            PrintAcrylicLabel,
            BulkPrintDataMatrix,
            ItemIntegrationDialog,
            BulkAllocationDialog
        },
    inject : ['brandProvider','categoryProvider','areaProvider','collectionProvider','filteredCategoryProvider','materialProvider','colourMasterProvider','sizeMasterProvider'],
    provide(){
        return {

        }
    },
    data(){
        return {
            endpoint : 'item-master/inventory',
            bulkUpdate : 'status',
            viewTransactionLoading : 0,
            showModal:false,
            tableKey : 0,
            filterForm : {
                searchTerm : null,
                supplierCode : null,
                itemName : null,
                ItmGroup : "0",
                brands : "0",
                collection : "0",
                category : ["0"],
                product_department_id : "0",
                product_category_id : "0",
                product_type_id : "0",
                product_attribute_id : [],
                product_attribute_filters : {},
                materials : "ALL",
                colour : "ALL",
                attribute : "ALL",
                status : "all",
                website : "all",
                availability : "0",
                in_transit : "0",
                under_production : "0",
                range : [-9999,9999],
            },
            area : [],
            productDepartments : [],
            productCategories : [],
            productTypes : [],
            productAttributes : [],
            productTypeAttributes : [],
            productTypeAttributesRequest : 0,
            productAttributesLoading : false,
            productTypeAttributesLoading : false,
            /* groups : [], */
           /*  brands : [], */
            category : [],
           /*  collections : [], */
            emailForm: {
                email:"",
                ItemCode: 'DEM001',
                ItemName: 'Demo Item 001',
                U_imgURL: 'https://media.thatsliving.com/public/uploads/image-jpeg/thumb-609a7771fdd9c7fa1c7b882f56b8398a-cncj-a302167-00.jpg', // Example static data
                Dimension: 'W26cm x H23cm'
            },
            itemWebsiteStatus : [
                {label : "ALL", value : "all"},
                {label : "YES", value : "1"},
                {label : "NO", value : "0"},
            ],

            itemStatus : [
                {label : "ALL", value : "all"},
                {label : "ACTIVE", value : "1"},
                {label : "DISCONTINUED", value : "0"},
            ],
            itemAvailabilityStatus : [
                {label : "ALL", value : "0"},
                {label : "AVAILABLE ONLY", value : "1"},
                {label : "ZERO AVAILABLE", value : "2"},
            ],
            itemInTransitStatus : [
                {label : "ALL", value : "0"},
                {label : "YES", value : "1"},
                {label : "NO", value : "2"},
            ],
            itemUnderProductionStatus : [
                {label : "ALL", value : "0"},
                {label : "YES", value : "1"},
                {label : "NO", value : "2"},
            ],
            slider:{
                    width: '100%',
                    min: 0,
                    max: 9999,
                    useKeyboard: true,
                    enableCross: true,
                    tooltipPlacement :'bottom',
                    tooltipFormatter : (v) => {
                        return `${('' + v).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                    }
            },
            dots : [0,99],
            vueSliderCtr : 0

        }
    },
    created(){
    },

    mounted(){
        const self = this;

        this.loadProductCategorizationFilters()

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
        // this.getSubCategory();
        // this.getUnitOfMeasurementsProduction();
    },
    methods: {
        async loadProductCategorizationFilters(){
            this.productAttributesLoading = true
            try {
                const responses = await Promise.all([
                    ApiHttpService.getRequest('product-departments', { length: 1000 }).catch(() => ({ data: [] })),
                    ApiHttpService.getRequest('category-master/all', { length: 1000 }).catch(() => ({ data: [] })),
                    ApiHttpService.getRequest('product-types', { length: 1000 }).catch(() => ({ data: [] })),
                    ApiHttpService.getRequest('product-attributes', { length: 1000, with_options: true }).catch(() => ({ data: [] })),
                ])

                const [departmentResponse, categoryResponse, productTypeResponse, attributeResponse] = responses

                const records = response => {
                    const payload = response.data || {}
                    return Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
                }

                this.productDepartments = records(departmentResponse)
                this.productCategories = records(categoryResponse)
                this.productTypes = records(productTypeResponse)
                this.productAttributes = records(attributeResponse)
            } finally {
                this.productAttributesLoading = false
            }
        },
        async loadProductTypeAttributes(productTypeId){
            const requestId = ++this.productTypeAttributesRequest
            this.productTypeAttributes = []
            this.productTypeAttributesLoading = false

            if(productTypeId === '0' || productTypeId === 0 || !productTypeId){
                return
            }

            this.productTypeAttributesLoading = true
            try {
                const response = await ApiHttpService.getRequest(`product-types/${productTypeId}/attributes`)
                if(requestId !== this.productTypeAttributesRequest){
                    return
                }

                const payload = response.data || {}
                this.productTypeAttributes = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : [])
            } catch (error) {
                if(requestId === this.productTypeAttributesRequest){
                    this.productTypeAttributes = []
                }
            } finally {
                if(requestId === this.productTypeAttributesRequest){
                    this.productTypeAttributesLoading = false
                }
            }
        },
        ...mapActions('GoodsReceiptNoteModule',{getGoodReceiptNote : 'getRecord'}),
        ...mapActions('SubCategoryModule',{getSubCategory : 'getAllRecords'}),
       ...mapActions('InventoryItemMasterModule',['getRecord','getTransactions']),
       ...mapMutations('InventoryItemMasterModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters','setFormData','setTerm']),
       ...mapMutations('InvoiceModule',{
            invoiceSetRecord : 'setFormRecord',
            invoiceStatusUpdate : 'setFormStatusUpdate',
            invoiceSetTblKey : 'setTblKey',
        }),
        ...mapActions('InvoiceModule',{
            invoiceGetRecord : 'getRecord',
            invoiceGetRecordSeries : 'getRecordSeries',
        }),
      /*   ...mapActions('UnitOfMeasurementModule',{
            getUnitOfMeasurementsProduction : 'getUnitOfMeasurementsProduction',
        }), */
        ...mapActions('QuantityAdjustModule',['getCustomerQuotation']),

        rowClick(row){
            const self = this;

            const mergeFormData = {...this.initialFormObject,...JSON.parse(JSON.stringify(row))}

       /*      const loading = Loading.service({
                fullscreen: true ,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            }); */
            self.setFormStatusUpdate();
            self.setFormData(mergeFormData);
            this.getRecord(mergeFormData)
            self.$refs.inventoryItemMasterForm.openDialog();
        },

        clearFilterForm(){
            this.setTerm('')
            Object.assign(this.filterForm, {
                searchTerm : null,
                supplierCode : null,
                itemName : null,
                ItmGroup : "0",
                brands : "0",
                collection : "0",
                category : ["0"],
                product_department_id : "0",
                product_category_id : "0",
                product_type_id : "0",
                product_attribute_id : [],
                product_attribute_filters : {},
                materials : "ALL",
                colour : "ALL",
                attribute : "ALL",
                status : "all",
                website : "all",
                availability : "0",
                in_transit : "0",
                under_production : "0",
                range : [-9999,9999],
            })
        },

        viewSoldTo(obj){
            this.$refs.itemSoldToWindow.triggerGetTransaction(obj)


        },
        viewRelatedDocument(obj){
            if(obj.reference == 'under_production_qty'){
                this.$refs.relatedDocumentDialogPurchaseOrder.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'in_transit_qty'){
                this.$refs.relatedDocumentDialogIncomingContainer.triggerGetTransaction(obj.row)
            }
            if(obj.reference == 'stock'){
                this.$refs.relatedDocumentDialogHistory.triggerGetTransaction(obj.row)
            }

        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.inventoryItemMasterForm.openDialog();
        },
        refreshTable(){
            // //alert(1)
            // this.tableKey++
            this.$refs.table.refreshTable()

        },

        itemSoldRowClickHandler(obj){
            const self = this;
            console.log("itemSoldRowClickHandler")
            console.log(obj)
            const form  = {...obj,items : [],attachment : [],invoice : {
                        series : null,
                        date : "",
                        balance : 0,
                        paid : 0,
                        attachment : [],
                        payments : [],
                    },
                    credit_note : {
                        total : 0,
                        status : null,
                        credit_note_reference : []
                    },
                    creditnotes : [],
                    credit_note_items : [],
                    cancellation : [],
                    cancellation_item : [],
                    refund : [],
                    refund_item : [],
                    exchange : [],
                    credit_memo : [],
                    exchange_item : [],
                    enable_push : false,
                    location : null,
                    }


                    if(!form.attr.hasOwnProperty('corporate')){
                            form.attr.corporate = false
                        }
                        if(!form.attr.hasOwnProperty('contact_person')){
                            form.attr.contact_person = {
                                name : null,
                                mobile : null,
                                attr : {

                                  address: null,
                                  address2 : {
                                      street : null,
                                      building : null,
                                      zone : null,
                                      area : null,
                                      city : null,
                                  },
                                  designation : null,
                                  email : null,
                                  first_name : null,
                                  middle_name : null,
                                  last_name : null,
                                  salutation : null
                                }
                              }
                        }
                    self.invoiceStatusUpdate()
                    self.invoiceSetRecord(form)
                    self.invoiceGetRecord({token_id : obj.token_id, series : obj.series})
                    this.invoiceSetTblKey(this.salesTblKey + 1);
                    this.$refs.invoiceForm.openDialog();

        },

        openCountryOfOriginDialog(){
            this.$refs.bulkUpdateCountryOfOrigin.openDialog();
        },
        openPrintStickerDialog(){
            this.$refs.bulkPrintQrCode.openDialog();
        },
        openBulkUpdateDialog(update){
            this.bulkUpdate = update;
            this.$refs.bulkUpdateItem.openDialog();
        },
        openBulkUpdateQuantityDialog(){
            this.$refs.updateQuantity.openDialog();
        },
        openBulkCreateQuantityDialog(){
            this.$refs.createProduct.openDialog();
        },
        openBulkCreateDialog(){
            this.$refs.bulkItemCreateOrUpdate.openDialog();
        },
        openBulkAllocationDialog(){
            this.$refs.bulkAllocationDialog.openDialog()
        },
        handleBulkAllocationSuccess(){
            this.refreshTable()
        },
        openItemIntegrationDialog(){
            this.$refs.itemIntegrationDialog.openDialog();
        },
        openBulkPrintDataMatrixDialog(){
            this.$refs.bulkPrintDataMatrix.openDialog();
        },
        openPrintCatalogDialog(){
            this.$refs.printCatalog2.openDialog();
        },
        openSyncItemMasterDialog(){
            this.$refs.syncItemMaster.openDialog();
        },
        openPrintAcrylicLabelDialog(){
            this.$refs.acrylicLabel.openDialog();
        },
        openEmailSend() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        tableSearchTerm(value){
           this.filterForm.searchTerm = value
        },
        ...mapActions('InventoryItemMasterModule',['sendEmailData']),
        onSubmitEmailForm() {
            this.sendEmailData(this.emailForm)
            this.showModal = false;
            this.emailForm.email = "";
        }


    },
    computed: {

        ...mapGetters('InvoiceModule',{
            salesTblKey: 'tblKey',
        }),

        ...mapGetters('InventoryItemMasterModule',['getLoading', 'columns','initialFormObject']),
        productDepartmentOptions(){
            return [{ label: 'ALL', value: '0' }, ...this.productDepartments.map(item => ({ label: item.name, value: item.id }))]
        },
        productCategoryOptions(){
            return [{ label: 'ALL', value: '0' }, ...this.productCategories.map(item => ({ label: item.name, value: item.id, department_id: item.department_id }))]
        },
        filteredProductCategoryOptions(){
            if(this.filterForm.product_department_id === '0' || this.filterForm.product_department_id === 0 || !this.filterForm.product_department_id){
                return this.productCategoryOptions
            }

            return [this.productCategoryOptions[0], ...this.productCategoryOptions.slice(1).filter(item => String(item.department_id) === String(this.filterForm.product_department_id))]
        },
        productTypeOptions(){
            return [{ label: 'ALL', value: '0' }, ...this.productTypes.map(item => ({
                label: item.name,
                value: item.id,
                category_id: item.category_id || (item.category && item.category.id),
                department_id: item.category && item.category.department_id,
            }))]
        },
        filteredProductTypeOptions(){
            let options = this.productTypeOptions.slice(1)

            if(this.filterForm.product_category_id !== '0' && this.filterForm.product_category_id !== 0 && this.filterForm.product_category_id){
                options = options.filter(item => String(item.category_id) === String(this.filterForm.product_category_id))
            } else if(this.filterForm.product_department_id !== '0' && this.filterForm.product_department_id !== 0 && this.filterForm.product_department_id){
                options = options.filter(item => String(item.department_id) === String(this.filterForm.product_department_id))
            }

            return [this.productTypeOptions[0], ...options]
        },
        productAttributeOptions(){
            const attributes = this.filterForm.product_type_id !== '0' && this.filterForm.product_type_id !== 0 && this.filterForm.product_type_id
                ? this.productTypeAttributes
                : this.productAttributes

            return attributes.map(item => ({ ...item, label: item.name, value: item.id }))
        },
        selectedFilterAttributes(){
            const selectedIds = Array.isArray(this.filterForm.product_attribute_id)
                ? this.filterForm.product_attribute_id.map(value => String(value))
                : []

            return this.productAttributeOptions.filter(attribute => {
                const filterable = attribute.pivot ? attribute.pivot.filterable !== false : attribute.filterable !== false
                return filterable && selectedIds.includes(String(attribute.id))
            })
        },
        brands : function(){
            const b = this.brandProvider();
           /*  return [...[
                {code : "0", brand : "ALL", parent : 0},
            ],...b] */


            if(["0"].includes(this.filterForm.ItmGroup)){
                return [...[
                {code : "0", brand : "ALL", parent : 0},
                ],...b];
            }else{
                const filteredData = b.filter((item) => item.parent === this.filterForm.ItmGroup,[])
                return [...[
                    {code : "0", brand : "ALL", parent : 0},
                ],...filteredData];
            }
        },
        /*
        groups : function(){
            const brandProviderData = this.brandProvider();
            const g = brandProviderData.filter((item) => item.parent == 0,[])
            return [...[
                {code : "0", brand : "ALL", parent : 0},
            ],...g]
        },
        */

        categoryComputed : function(){
            return this.categoryProvider();
        },
        areaComputed : function(){
            return this.areaProvider();
        },

        collections : function(){
            const c = this.collectionProvider();
           /*  return [...[
                {mdbID : "0",name : "ALL", brand_id : 0},
            ],...c]; */

            if(["0"].includes(this.filterForm.brands)){
                return [...[
                {mdbID : "0",name : "ALL", brand_id : 0},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brand_id == this.filterForm.brands,[])
                return [...[
                    {mdbID : "0",name : "ALL", brand_id : 0},
                ],...filteredData];
            }


        },

        filteredCategory : function(){

            const c = this.filteredCategoryProvider();

            if(["0"].includes(this.filterForm.brands)){
                return [...[
                {id : "0",name : "ALL", attributes : []},
                ],...c];
            }else{
                const filteredData = c.filter((item) => item.brands.includes(this.filterForm.brands),[])
                return [...[
                    {id : "0",name : "ALL", attributes : []},
                ],...filteredData];
            }
        },
        materials : function(){
            const self = this
            const c = this.materialProvider();

            if(["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                return [...[
                {id : "0",name : "ALL", attributes : []},
                ],...c];
            }else{

                let fileteredData = [];
                if(!["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.brands.includes(this.filterForm.brands),[])
                }

                if(["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.category.some(value => self.filterForm.category.includes(value)),[])
                }

                if(!["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.brands.includes(this.filterForm.brands) && item.category.some(value => self.filterForm.category.includes(value)),[])
                }

                return [...[
                    {id : "0",name : "ALL", attributes : []},
                ],...fileteredData];


            }
        },
        colours : function(){
            const self = this
            const c = this.colourMasterProvider();

            console.log("colours")
            console.log(c)

            if(["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                return [...[
                {id : "0",name : "ALL", attributes : []},
                ],...c];
            }else{

                let fileteredData = [];
                if(!["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.brands.includes(this.filterForm.brands),[])
                }

                if(["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.category.some(value => self.filterForm.category.includes(value)),[])
                }

                if(!["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                    fileteredData = c.filter((item) => item.brands.includes(this.filterForm.brands) && item.category.some(value => self.filterForm.category.includes(value)),[])
                }
                return [...[
                    {id : "0",name : "ALL", attributes : []},
                ],...fileteredData];
            }

            // return []
        },

        sizes : function(){
            const self = this
            const s = this.sizeMasterProvider();

            console.log("sizeMasterProvider")
            console.log(s)

            if(["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                return [...[
                {id : "0",name : "ALL", attributes : []},
                ],...s];
            }else{

                    let fileteredData = [];
                    if(!["0"].includes(this.filterForm.brands) && ["0"].some(value => self.filterForm.category.includes(value))){
                        fileteredData = s.filter((item) => item.brands.includes(this.filterForm.brands),[])
                    }

                    if(["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                        fileteredData = s.filter((item) => item.category.some(value => self.filterForm.category.includes(value)),[])
                    }

                    if(!["0"].includes(this.filterForm.brands) && !["0"].some(value => self.filterForm.category.includes(value))){
                        fileteredData = s.filter((item) => item.brands.includes(this.filterForm.brands) && item.category.some(value => self.filterForm.category.includes(value)),[])
                    }
                    return [...[
                        {id : "0",name : "ALL", attributes : []},
                    ],...fileteredData];
                }
        },

    },

    watch : {
      'filterForm.product_department_id': function(value){
          const selectedCategory = this.productCategoryOptions.find(item => String(item.value) === String(this.filterForm.product_category_id))
          if(selectedCategory && String(selectedCategory.department_id) !== String(value)){
              this.filterForm.product_category_id = '0'
          }

          const selectedProductType = this.productTypeOptions.find(item => String(item.value) === String(this.filterForm.product_type_id))
          if(selectedProductType && value && value !== '0' && value !== 0 && String(selectedProductType.department_id) !== String(value)){
              this.filterForm.product_type_id = '0'
          }
      },
      'filterForm.product_category_id': function(value){
          const selectedProductType = this.productTypeOptions.find(item => String(item.value) === String(this.filterForm.product_type_id))
          if(selectedProductType && value && value !== '0' && value !== 0 && String(selectedProductType.category_id) !== String(value)){
              this.filterForm.product_type_id = '0'
          }
      },
      'filterForm.product_type_id': function(value){
          this.filterForm.product_attribute_id = []
          this.filterForm.product_attribute_filters = {}
          this.loadProductTypeAttributes(value)
      },
      'filterForm.product_attribute_id': function(value){
          const selectedIds = Array.isArray(value) ? value.map(id => String(id)) : []
          const currentFilters = this.filterForm.product_attribute_filters || {}
          const nextFilters = {}

          selectedIds.forEach(id => {
              nextFilters[id] = Object.prototype.hasOwnProperty.call(currentFilters, id) ? currentFilters[id] : null
          })

          this.filterForm.product_attribute_filters = nextFilters
      },
       /*  brandGroupComputed : function(value){
            console.log("watch brandGroupComputed")
            console.log(value)
            this.groups = [...[
                {code : "0", brand : "All", parent : 0},
            ],...value]
        }, */
       /*  brandComputed : function(value){
            console.log("watch brandComputed")
            console.log(value)
            this.brands = [...[
                {code : "0", brand : "All", parent : 0},
            ],...value]
        }, */
        categoryComputed : function(value){
          console.log("watch category")
          console.log(value)


          const uniqueCodesAndAreas = {};

            // Filter the array based on unique codes and areas
            const filteredData = value.filter(item => {
            const key = `${item.code}-${item.area}`;
            if (!uniqueCodesAndAreas[key]) {
                // If the code and area combination is not present, mark it as seen and keep the item
                uniqueCodesAndAreas[key] = true;
                return true;
            }
            // If the code and area combination is already seen, discard the item
            return false;
            },[]);

            console.log("filteredData");
            console.log(filteredData);
            console.log(value);

          this.category = [...[
                {code : "0", area : "",category : "All", attributes : []},
            ],...filteredData]
      },
      areaComputed : function(value){
          console.log("watch area")
          console.log(value)
          this.area = value
      },
     /*  collectionComputed : function(value){
          console.log("watch collectionComputed")
          console.log(value)
          this.collections = [...[
                {mdbID : "0",name : "ALL", brand_id : 0},
            ],...value]
      }, */

      "filterForm.ItmGroup" : function(){
            console.log("watch ItmGroup")
            console.log(this.filterForm.ItmGroup)

            // this.brands = this.brandProvider().filter((item) => item.parent == this.filterForm.ItmGroup,[])

           /*  if(this.filterForm.ItmGroup == "" || this.filterForm.ItmGroup == null){
                this.brands = this.brandProvider().filter((item) => item.parent == 0,[])
            }else{
                const brandArray = this.brandProvider().filter((item) => item.parent == this.filterForm.ItmGroup,[])
                this.brands = [...[
                                {code : "0", brand : "ALL", parent : 0},
                            ],...brandArray]

            } */

            this.filterForm.brands = "0"
            this.filterForm.collection = "0"
            this.filterForm.collection = "0"
            this.filterForm.materials = "ALL"
            this.filterForm.category = ["0" ]
            this.filterForm.colour = "ALL"
            this.filterForm.attribute = "ALL"
            // this.collections = [{mdbID : "0",name : "ALL", brand_id : 0}]

        },
        "filterForm.brands" : function(){
            console.log("watch brands")
            // console.log(this.filterForm.brands)
            // this.brands = this.brandProvider().filter((item) => item.parent == this.filterForm.ItmGroup,[])

    /*         if(this.filterForm.brands == "" || this.filterForm.brands == null){
                this.collections = this.collectionProvider();
            }else{
                const filteredData = this.collectionProvider().filter((item) => item.brand_id == this.filterForm.brands,[])

                this.collections = [...[
                    {mdbID : "0",name : "ALL", brand_id : 0},
                ],...filteredData]

            } */

            this.filterForm.collection = "0"
            this.filterForm.materials = "ALL"
            this.filterForm.category = ["0" ]
            this.filterForm.colour = "ALL"
            this.filterForm.attribute = "ALL"
        },

        "filterForm.availability" : function(value){
            console.log("filterForm.availability")
            console.log(value)

            if(value == "0"){
                this.slider.min = -9999
                this.slider.max = 9999

                this.filterForm.range = [-9999,9999]
            }

            if(value == "1"){
                this.slider.min = 1
                this.slider.max = 9999
                this.filterForm.range = [1,9999]
            }

            if(value == "2"){
                this.slider.min = -9999
                this.slider.max = 0
                this.filterForm.range = [-9999,0]
            }
            this.vueSliderCtr++
        }

    }
}


</script>
